<template>
  <div>
    <div v-if="!infoFlag">
      <v-date-picker range
                     placeholder="请选择时间段"
                     style="width:300px;"
                     v-model="rangeDate"
                     clearable
                     @confirm="confirm"
                     @change="rangeChange"></v-date-picker>
      <v-select style="width: 200px;"
                :data="appOptions"
                placeholder="请选择产品"
                :allowClear="false"
                v-model="appValue"></v-select>
      <v-select style="width: 200px;"
                :data="statusOptions"
                v-model="statusValue"
                placeholder="请选择付款类型"></v-select>
      <v-button type="primary"
                @click="exportExl">导出</v-button>
      <div style="height:20px"></div>
      <v-select style="width: 200px;"
                :data="queryOption"
                v-model="queryType"
                placeholder="请选择查询条件"></v-select>
      <v-input placeholder="订单号/交易单号/商户单号查询"
               v-model="queryValue"
               style="width:220px;display:inline-block"></v-input>
      <v-button type="primary"
                @click="search">查询</v-button>
      <div style="height:20px;"></div>
      <el-table :data="tableData"
                v-if="tableFlag"
                style="width: 100%">
        <el-table-column prop="order_id"
                         label="订单号">
        </el-table-column>
        <el-table-column prop="payment_state"
                         label="状态">
        </el-table-column>
        <el-table-column prop="create_time"
                         label="创建时间">
        </el-table-column>
        <el-table-column prop="payment_time"
                         label="支付时间">
        </el-table-column>
        <el-table-column label="分享优惠">
          <template slot-scope="scope">
            <span>¥</span>
            <span>{{ scope.row.discounted_price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="应付价格">
          <template slot-scope="scope">
            <span v-if="tableData[0].amounts_payable">¥</span>
            <span>{{ scope.row.amounts_payable }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)"
                       type="text"
                       size="small">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <v-row v-else>
      <v-modal title="标记已支付"
               :width=600
               :visible="replyVisible"
               @ok="handlePay"
               @cancel="replyVisible=false">
        <div style="margin: 10px 20px;display: flex">
          <p style="width:100px;">标记订单号</p>
          <p style="width:300px">{{tableData[0].order_id}}</p>
        </div>
        <div style="margin: 10px 20px;display: flex">
          <p style="width:100px;">支付方式</p>
          <el-input
            type="text"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="支付宝|微信"
            v-model="pay_type">
          </el-input>
        </div>
        <div style="margin: 10px 20px;display: flex">
          <p style="width:100px;">支付金额</p>
          <el-input
            type="number"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="单位:分"
            v-model="fee">
          </el-input>
        </div>
        <div style="margin: 10px 20px;display: flex">
          <p style="width:100px;">第三方订单号</p>
          <el-input
            type="text"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入订单号"
            v-model="three_order_id">
          </el-input>
        </div>
        <div style="margin: 10px 20px;display: flex">
          <p style="width:100px;">订单备注</p>
          <el-input
            type="text"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入备注内容"
            v-model="remark">
          </el-input>
        </div>
      </v-modal>
      <v-col span="8">
        <v-card title="基本信息"
                @mouseleave.native="changeShow"
                @mouseenter.native="changeShow">
          <v-row>
            <v-col span="6">
              应用名称
            </v-col>
            <v-col span="18">
              {{tableData[0].app_name}}
            </v-col>
          </v-row>
          <v-row>
            <v-col span="6">
              订单号
            </v-col>
            <v-col span="18">
              {{tableData[0].order_id}}
            </v-col>
          </v-row>
          <v-row>
            <v-col span="6">
              交易单号
            </v-col>
            <v-col span="18">
              {{tableData[0].transaction_number}}
            </v-col>
          </v-row>
          <v-row>
            <v-col span="6">
              流水号
            </v-col>
            <v-col span="18">
              {{tableData[0].serial_number}}
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col span="6">
              订单类型
            </v-col>
            <v-col span="18">
              存储订单
            </v-col>
          </v-row> -->
          <v-row>
            <v-col span="6">
              订单状态
            </v-col>
            <v-col span="18">
              {{tableData[0].payment_state}}
            </v-col>
          </v-row>

          <v-row>
            <v-col span="6">
              创建时间
            </v-col>
            <v-col span="18">
              {{tableData[0].create_time}}
            </v-col>
          </v-row>
          <v-row>
            <v-col span="6">
              支付时间
            </v-col>
            <v-col span="18">
              {{tableData[0].payment_time}}
            </v-col>
          </v-row>
          <v-row>
            <v-col span="6">
              提取码
            </v-col>
            <v-col span="18">
              {{tableData[0].extract_code}}
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col span="6">
              合并支付
            </v-col>
            <v-col span="18">
              否
            </v-col>
          </v-row>
          <v-row>
            <v-col span="6">
              余额支付
            </v-col>
            <v-col span="18">
              否
            </v-col>
          </v-row>
          <v-row>
            <v-col span="6">
              退款时间
            </v-col>
            <v-col span="18">
              2019-01-31 16:34:52.165501+08:00
            </v-col>
          </v-row> -->
        </v-card>
        <div style="height:20px;"></div>
        <v-card title="照片信息"
                @mouseleave.native="changeShow"
                @mouseenter.native="changeShow">
          <v-row>
            <v-col span="18">
              规格
            </v-col>
            <v-col span="6">
              {{tableData[0].spec_name}}
            </v-col>
          </v-row>
        </v-card>
        <div style="height:20px;"></div>
        <v-card title="价格信息"
                @mouseleave.native="changeShow"
                @mouseenter.native="changeShow">
          <v-row>
            <v-col span="18">
              应付金额
            </v-col>
            <v-col span="6">
              <span v-if="tableData[0].amounts_payable">¥</span>{{tableData[0].amounts_payable}}
            </v-col>
          </v-row>
          <v-row>
            <v-col span="18">
              优惠金额
            </v-col>
            <v-col span="6">
              ¥{{tableData[0].discounted_price}}
            </v-col>
          </v-row>
          <v-row>
            <v-col span="18">
              实付金额
            </v-col>
            <v-col span="6">
              ¥{{tableData[0].actual_payment_amount}}
            </v-col>
          </v-row>
          <div slot="extra"
               v-show="true">
            <v-button type="warning"
                  style="margin-right:20px;"
                  :disabled="!tableData[0].is_mark_refund"
                  @click="markRefund">标记退款</v-button>
            <v-button type="error"
                      :disabled="!tableData[0].is_refund"
                      @click="refund">退款</v-button>

            <v-button type="error"
                      :disabled="!tableData[0].sign_pay_status"
                      @click="sign_pay">标记支付</v-button>
          </div>
        </v-card>
        <div style="height:20px;"></div>
        <!-- <v-card title="用户信息"
                @mouseleave.native="changeShow"
                @mouseenter.native="changeShow">
          <v-row>
            <v-col span="18">
              编号
            </v-col>
            <v-col span="6">
              21457497
            </v-col>
          </v-row>
          <v-row>
            <v-col span="18">
              当前关联钱包
            </v-col>
            <v-col span="6">
              未关联
            </v-col>
          </v-row>
        </v-card> -->
        <div style="height:20px;"></div>
        <v-card title="备注信息"
                @mouseleave.native="changeShow"
                @mouseenter.native="changeShow">
          <div class="source-info">
            {{tableData[0].remark}}
          </div>
        </v-card>
      </v-col>
      <v-col span="16">
        <v-tabs active-tab-key="key1"
                style="padding-left:20px;"
                @change="onChange"
                @tab-click="onTabClick">
          <v-tab-pane tab-key="key1"
                      tab="电子照">
            <img :src="tableData[0].ele_url"
                 style="width:100%" />
          </v-tab-pane>
          <v-tab-pane tab-key="key2"
                      tab="原图">
            <img :src="tableData[0].original_url"
                 style="width:100%" />
          </v-tab-pane>
          <v-tab-pane tab-key="key3"
                      tab="排版照">
            <img :src="tableData[0].print_url"
                 style="width:100%" />
          </v-tab-pane>
          <v-button slot="extra"
                    style="margin-right: 5px;"
                    ghost
                    type="primary"
                    @click="goBackToTable"
                    icon="left">返回</v-button>
        </v-tabs>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      queryValue: '',
      queryType: '',
      queryOption: [],
      appOptions: [],
      appValue: '',
      statusOptions: [],
      statusValue: '',
      rangeDate: ['', ''],
      tableFlag: false,
      infoFlag: false,
      tableData: [],
      replyVisible: false,
      pay_type: '',
      fee: 0,
      three_order_id: '',
      remark: ''
    }
  },
  methods: {
    handlePay () {
      axios.post('/dev/mark_pay/' + this.tableData[0].order_id, { pay_type: this.pay_type,
        fee: this.fee,
        three_order_id: this.three_order_id,
        remark: this.remark })
        .then(res => {
          this.search()
          this.replyVisible = false
        })
    },
    markRefund () {
      this.$modal.confirm({
        title: '提示',
        content: '您是否确认要标记退款',
        onOk: () => {
          axios.post('/dev/mark_refund/' + this.tableData[0].order_id)
            .then(res => {
              if (res.data.code === 200) {
                this.$message['success']('标记退款成功')
                this.search()
              }
            })
        }
      })
    },
    refund () {
      this.$modal.confirm({
        title: '提示',
        content: '您是否确认要退款',
        onOk: () => {
          axios.post('/dev/refund/' + this.tableData[0].order_id)
            .then(res => {
              if (res.data.code === 200) {
                this.$message['success']('退款成功')
                this.search()
              }
            })
        }
      })
    },
    sign_pay () {
      this.replyVisible = true
    },
    exportExl () {
      let startTime, endTime
      if (this.rangeDate[0] !== '') {
        startTime = parseInt(new Date(this.rangeDate[0]).getTime() / 1000)
        endTime = parseInt(new Date(this.rangeDate[1]).getTime() / 1000)
      } else {
        this.$message['error']('请选择时间')
        return
      }
      let url = 'dev/export_order'
      url = url + '/' + startTime + '/' + endTime + '?package_key=' + this.appValue + '&payment_state_id=' + this.statusValue
      axios.get(url)
        .then(res => {
          if (res.data.download_link) {
            window.location.href = res.data.download_link
          }
        })
    },
    formatUnixtimestamp (unixtimestamp) {
      unixtimestamp = new Date(unixtimestamp * 1000)
      var year = 1900 + unixtimestamp.getYear()
      var month = '0' + (unixtimestamp.getMonth() + 1)
      var date = '0' + unixtimestamp.getDate()
      var hour = '0' + unixtimestamp.getHours()
      var minute = '0' + unixtimestamp.getMinutes()
      var second = '0' + unixtimestamp.getSeconds()
      return year + '-' + month.substring(month.length - 2, month.length) + '-' + date.substring(date.length - 2, date.length) +
        ' ' + hour.substring(hour.length - 2, hour.length) + ':' +
        minute.substring(minute.length - 2, minute.length) + ':' +
        second.substring(second.length - 2, second.length)
    },
    formatTime (time) {
      if (!time) {
        return ''
      }
      return this.formatUnixtimestamp(time)
    },
    getQueryInfo () {
      axios.get('/dev/order_inquiry_item').then(res => {
        let arr = []
        res.data.search_type.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.queryOption = arr
      }).catch(err => { console.log(err) })
    },
    getApps () {
      axios.get('/dev/package_info').then(res => {
        let arr = []
        res.data.package_info.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.appOptions = arr
      }).catch(err => { console.log(err) })
    },
    getPayment () {
      axios.get('/dev/payment_state').then(res => {
        let arr = []
        res.data.payment_state.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.statusOptions = arr
      }).catch(err => { console.log(err) })
    },
    onTabClick () {

    },
    onChange () {

    },
    changeShow () {

    },
    handleClick () {
      this.infoFlag = true
    },
    goBackToTable () {
      this.infoFlag = false
    },
    search () {
      if (this.queryType === '') {
        this.$message['error']('请选择查询类型')
        return
      }
      if (this.queryValue === '') {
        this.$message['error']('请输入查询单号')
        return
      }
      axios.get('/dev/order/' + this.queryValue + '?search_type=' + this.queryType).then(res => {
        console.log(res)
        if (res.data.code !== 200) {
          this.tableData = []
        } else {
          res.data.result.create_time = this.formatTime(res.data.result.create_time)
          res.data.result.payment_time = this.formatTime(res.data.result.payment_time)
          res.data.result.sign_pay_status = res.data.result.payment_state === '待支付'
          this.tableData = new Array(res.data.result)
        }
      }).catch(err => { console.log(err) })
      this.tableFlag = true
    },
    confirm () {
      console.log('confirm')
    },
    change (time) {
      console.log('change:', time)
    },
    rangeChange (startTime, endTime) {
      console.log('change:', startTime, endTime)
    }
  },
  mounted () {
    this.getApps()
    this.getPayment()
    this.getQueryInfo()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/order/order.vue